import request from '@/utils/request'
const serivceBase = require('@/config/serviceConfig')

export const RIGHT_ACTIVITY_TOKEN_KEY = 'rightActivityToken'

const getToken = () => sessionStorage.getItem(RIGHT_ACTIVITY_TOKEN_KEY) || ''

// 权益活动H5-获取活动信息
export const getActivity = (bizType) => {
  return request({
    url: `${serivceBase.CUSTOM}/rightActivityH5/getActivity/${bizType}`,
    method: 'post',
    custom: true
  })
}
// 权益活动H5-获取验证码
export const sendCaptcha = (data) => {
  return request({
    url: `${serivceBase.CUSTOM}/rightActivityH5/sendCaptcha`,
    method: 'post',
    data
  })
}
// 权益活动H5-登录
export const login = (data) => {
  return request({
    url: `${serivceBase.CUSTOM}/rightActivityH5/login`,
    method: 'post',
    data
  })
}
// 权益活动H5-奖品分页查询
export const orderPages = (data) => {
  return request({
    url: `${serivceBase.CUSTOM}/rightActivityH5/order/pages`,
    method: 'post',
    data,
    token: getToken(),
    custom: true
  })
}
// 权益活动H5-领取奖品
export const receiveOrder = (orderId) => {
  return request({
    url: `${serivceBase.CUSTOM}/rightActivityH5/order/receive/${orderId}`,
    method: 'post',
    token: getToken(),
    custom: true
  })
}
